import React from "react";
import {decimalAdjust} from "../../Global";
import TablaPagosComponent from "./TablaPagosComponent";
import TablaNotasCreditoComponent from "./TablaNotasCreditoComponent";

export default class DetalleDeudaComponent extends React.Component {

    constructor(props) {
        super(props);
    }

    getDeuda() {
        let totalPagado = this.props.deuda.pagos
            .filter(p => p.Estado === 'PAGADO').map(p => Number(p.TotalPagado)).reduce((a, b) => a + b, 0);
        return Number(this.props.deuda.Total) - Number(totalPagado);
    }

    render() {
        const totalRestante = this.getDeuda();
        const {pagos, notasCredito, notasCreditoAnuladas} = this.props.deuda;

        return (
            <div>
                <div className="row mt-1">
                    <div className="col-sm-auto">
                        Total restante: {decimalAdjust('floor', totalRestante, -2)}
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-sm-12">
                        <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <a className="nav-link active" id="pills-home-tab" data-toggle="pill" href="#pills-home"
                                   role="tab" aria-controls="pills-home" aria-selected="true">Pagos</a>
                            </li>
                            <li className="nav-item" role="presentation">
                                <a className="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-profile"
                                   role="tab" aria-controls="pills-profile" aria-selected="false">Notas de crédito</a>
                            </li>
                        </ul>
                        <div className="tab-content" id="pills-tabContent">
                            <div className="tab-pane fade show active" id="pills-home" role="tabpanel"
                                 aria-labelledby="pills-home-tab">
                                <TablaPagosComponent pagos={pagos} readOnly={true}/>
                            </div>
                            <div className="tab-pane fade" id="pills-profile" role="tabpanel"
                                 aria-labelledby="pills-profile-tab">
                                <TablaNotasCreditoComponent notasCredito={notasCredito.concat(notasCreditoAnuladas)}/>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}
